import { render } from "./TableDisplay.vue?vue&type=template&id=0c4a7870&scoped=true"
import script from "./TableDisplay.vue?vue&type=script&lang=js"
export * from "./TableDisplay.vue?vue&type=script&lang=js"

import "./TableDisplay.vue?vue&type=style&index=0&id=0c4a7870&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4a7870"],['__file',"src/views/AfterSales/components/TableDisplay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c4a7870"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c4a7870', __exports__)) {
    api.reload('0c4a7870', __exports__)
  }
  
  module.hot.accept("./TableDisplay.vue?vue&type=template&id=0c4a7870&scoped=true", () => {
    api.rerender('0c4a7870', render)
  })

}


export default __exports__